import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type { SortDirection } from '../types';
import styles from './templates-table.module.css';

interface SortableHeaderProps<K extends string> {
  label: string;
  columnKey: K;
  activeSortKey: K;
  sortDirection: SortDirection;
  toggleSort: (key: K) => void;
}

export function SortableHeader<K extends string>({
  label,
  columnKey,
  activeSortKey,
  sortDirection,
  toggleSort,
}: SortableHeaderProps<K>) {
  const isActive = activeSortKey === columnKey;
  let ariaSort: 'ascending' | 'descending' | 'none' = 'none';
  if (isActive) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return (
    <th aria-sort={ariaSort}>
      <button type="button" className={styles.sortButton} onClick={() => toggleSort(columnKey)}>
        {label}
        {!isActive && <ArrowUpDown className={styles.sortIcon} aria-hidden="true" />}
        {isActive && sortDirection === 'asc' && (
          <ArrowUp className={styles.sortIcon} aria-hidden="true" />
        )}
        {isActive && sortDirection === 'desc' && (
          <ArrowDown className={styles.sortIcon} aria-hidden="true" />
        )}
      </button>
    </th>
  );
}
